// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dialog {
  width: 80%;
  height: 100vh;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

dialog::backdrop {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(2px);
}

html:has(dialog[open]) {
  overflow: hidden;
}

.ys-modal-dialog {
  position: fixed;
  height: 100vh;
}

.ys-modal-close-button {
  position: absolute;
  top: 50px;
  left: 25px;
  z-index: 10;
  border-radius: 0.5rem;
  /* background: #595959; */
  /* border: 1px solid #e5e7eb; */
  /* cursor: pointer; */
  /* line-height: 1; */
}

.tab-marche .yousign-iframe-container {
  width: 100%;
  /* margin: 2rem 0; */
  border: none !important;
  overflow: hidden;
}

.signature-pending > h4 {
  margin-top: 1rem;
}

.notifications-table-container {
  border: 1px solid #e5e7eb !important;
  border-radius: 10px;
}

.prestataires-table {
  width: 100%;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
}

.prestataires-table th,
.prestataires-table td {
  padding: 14px 20px;
  text-align: left;
}

.prestataires-table th {
  background-color: #f9f9f9;
  font-weight: 600;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.prestataires-table tr:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

tbody:last-child td {
  border: none;
}

.prestataires-table tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.prestataires-table tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

span.signataire {
  font-weight: 800;
  /* font-style: italic; */
}

/* .prestataires-table tr {
  cursor: pointer;
} */

.prestataires-table tr.retained {
  background-color: #e9ffee; /* vert clair */
  font-weight: 800;
}

.prestataires-table tr.not-retained {
  background-color: #eeeeee;
  color: #9f9f9f;
}

button.notify-btn.button {
  border-radius: 0.5rem;
  /* padding: 1rem !important; */
}

/* .prestataires-table tr.not-retained:hover {
  background-color: initial;
  color: initial;
} */

.actions-cell {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.notify-btn,
.pdf-btn {
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s ease, transform 0.1s ease;
}

.notify-btn {
  background-color: #2563eb;
  color: white;
}

.notify-btn:hover {
  background-color: #1d4ed8;
  transform: scale(1.03);
}

.pdf-btn {
  background-color: #10b981;
  color: white;
}

.pdf-btn:hover {
  background-color: #059669;
  transform: scale(1.03);
}

.signature-waiting {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.notification-sent {
  color: #10b981;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  /* font-size: 0.875rem; */
}

.notification-sent::before {
  content: "✓";
  font-weight: bold;
}

.notification-warning {
  background-color: #fef3c7;
  border-left: 4px solid #f59e0b;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
}

.notification-warning h4 {
  color: #b45309;
  margin: 0 0 0.5rem 0;
}

.notification-warning p {
  color: #92400e;
  margin: 0;
  font-size: 0.875rem;
}

.notification-na {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}

.notify-btn:disabled {
  opacity: 0.7;
  cursor: wait;
  background-color: #e2e8f0;
}

.notification-sent {
  color: #10b981;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.notification-sent::before {
  content: "✓";
  font-weight: bold;
}

.notification-na {
  color: #6b7280;
  font-style: italic;
}

.notification-info {
  margin-bottom: 2rem;
  font-weight: 500;
  font-size: 1.15em;
}

.actions-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.act-btn {
  font-size: 1.2rem !important;
  width: 100%;
}

.print-button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.send-to-presta-button {
  margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Marche/Marche.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,yBAAyB,EAAE,eAAe;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB","sourcesContent":["dialog {\n  width: 80%;\n  height: 100vh;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n}\n\ndialog::backdrop {\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(2px);\n}\n\nhtml:has(dialog[open]) {\n  overflow: hidden;\n}\n\n.ys-modal-dialog {\n  position: fixed;\n  height: 100vh;\n}\n\n.ys-modal-close-button {\n  position: absolute;\n  top: 50px;\n  left: 25px;\n  z-index: 10;\n  border-radius: 0.5rem;\n  /* background: #595959; */\n  /* border: 1px solid #e5e7eb; */\n  /* cursor: pointer; */\n  /* line-height: 1; */\n}\n\n.tab-marche .yousign-iframe-container {\n  width: 100%;\n  /* margin: 2rem 0; */\n  border: none !important;\n  overflow: hidden;\n}\n\n.signature-pending > h4 {\n  margin-top: 1rem;\n}\n\n.notifications-table-container {\n  border: 1px solid #e5e7eb !important;\n  border-radius: 10px;\n}\n\n.prestataires-table {\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n  border-radius: 10px;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n\n.prestataires-table th,\n.prestataires-table td {\n  padding: 14px 20px;\n  text-align: left;\n}\n\n.prestataires-table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.prestataires-table tr:not(:last-child) {\n  border-bottom: 1px solid #e5e7eb;\n}\n\ntbody:last-child td {\n  border: none;\n}\n\n.prestataires-table tr:last-child td:first-child {\n  border-bottom-left-radius: 10px;\n}\n\n.prestataires-table tr:last-child td:last-child {\n  border-bottom-right-radius: 10px;\n}\n\nspan.signataire {\n  font-weight: 800;\n  /* font-style: italic; */\n}\n\n/* .prestataires-table tr {\n  cursor: pointer;\n} */\n\n.prestataires-table tr.retained {\n  background-color: #e9ffee; /* vert clair */\n  font-weight: 800;\n}\n\n.prestataires-table tr.not-retained {\n  background-color: #eeeeee;\n  color: #9f9f9f;\n}\n\nbutton.notify-btn.button {\n  border-radius: 0.5rem;\n  /* padding: 1rem !important; */\n}\n\n/* .prestataires-table tr.not-retained:hover {\n  background-color: initial;\n  color: initial;\n} */\n\n.actions-cell {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.notify-btn,\n.pdf-btn {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.notify-btn {\n  background-color: #2563eb;\n  color: white;\n}\n\n.notify-btn:hover {\n  background-color: #1d4ed8;\n  transform: scale(1.03);\n}\n\n.pdf-btn {\n  background-color: #10b981;\n  color: white;\n}\n\n.pdf-btn:hover {\n  background-color: #059669;\n  transform: scale(1.03);\n}\n\n.signature-waiting {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.notification-sent {\n  color: #10b981;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  /* font-size: 0.875rem; */\n}\n\n.notification-sent::before {\n  content: \"✓\";\n  font-weight: bold;\n}\n\n.notification-warning {\n  background-color: #fef3c7;\n  border-left: 4px solid #f59e0b;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 0.375rem;\n}\n\n.notification-warning h4 {\n  color: #b45309;\n  margin: 0 0 0.5rem 0;\n}\n\n.notification-warning p {\n  color: #92400e;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.notification-na {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 0.875rem;\n}\n\n.notify-btn:disabled {\n  opacity: 0.7;\n  cursor: wait;\n  background-color: #e2e8f0;\n}\n\n.notification-sent {\n  color: #10b981;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.notification-sent::before {\n  content: \"✓\";\n  font-weight: bold;\n}\n\n.notification-na {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.notification-info {\n  margin-bottom: 2rem;\n  font-weight: 500;\n  font-size: 1.15em;\n}\n\n.actions-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.act-btn {\n  font-size: 1.2rem !important;\n  width: 100%;\n}\n\n.print-button-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n.send-to-presta-button {\n  margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
